import UserProfileForm from './UserProfileForm'

export default UserProfileForm
